
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useDuplicateList } from '@/modules/duplicate/item/model/list';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { DuplicateItemOptions } from '@/modules/duplicate/item/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_DUPLICATE.ITEM.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = useDuplicateList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: DuplicateItemOptions.Type },
                { type: TableColumnType.Text, label: 'Cost', key: 'cost' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Match',
                    key: 'matchName',
                    to: (row: any) => ({ name: ROUTE_NAME_GAME.MATCH.DETAIL, params: { id: row.matchId } })
                },
                { type: TableColumnType.Text, label: 'Game', key: 'game' },
                { type: TableColumnType.DateTime, label: 'Publish Time', key: 'publishTime' },
                { type: TableColumnType.DateTime, label: 'Next Start Time', key: 'nextStartTime' },
                { type: TableColumnType.DateTime, label: 'Unpublish Time', key: 'unpublishTime' },
                {
                    type: TableColumnType.Image,
                    label: 'Thumbnail',
                    imageKey: 'thumbnail',
                    statusKey: 'thumbnailStatus'
                },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: DuplicateItemOptions.Status },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_DUPLICATE.ITEM.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_DUPLICATE.ITEM.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_DUPLICATE.ITEM.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Enable',
                        onclick: () => actions.enable(row.id)
                    }),
                    canShow: (row: any) => row.canEnable && row.status == 0,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Disable',
                        onclick: () => actions.disable(row.id)
                    }),
                    canShow: (row: any) => row.canDisable,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_DUPLICATE };
    }
});
